import React from 'react';
import styled from 'styled-components';
import { BorderSquareSection } from '../../../../view/Sections/BorderSquareSection';
import knowledge from '../../../../img/MainPage/knowledge.png';
import { BasicRoundedLink } from '../../../../view/Buttons';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const KnowledgeSection = (): JSX.Element => (
  <BorderSquareSection
    subHeader="WIEDZA"
    header="Z natury"
    buttonText="Nasze uprawy"
    img={knowledge}
  >
    <>
      Od pokoleń znamy się na owocach.
      <br />
      Używamy starych, sprawdzonych receptur,
      <br />
      naszych własnych owoców, a przetwory robimy ręcznie,
      <br />
      naszym zdaniem  jest to najlepszy sposób na zachowanie
      ich właściwosci prozdrowotnych.
      <ButtonWrapper>
        <BasicRoundedLink rel="noreferrer noopener nofollow" href="http://www.blog.owocowo.com.pl/">
          Blog
        </BasicRoundedLink>
      </ButtonWrapper>
    </>
  </BorderSquareSection>
);
